class ManufactureTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    try {
      this.tabButtons = this.querySelectorAll(".manufacture-tab");
      this.detailsItems = this.querySelectorAll(
        ".manufacture-tab-details-wrapper"
      );
      this.tabButtons.forEach((tab) => {
        tab.addEventListener("click", () => this.activateTab(tab));
      });
    } catch (error) {
      console.error("[ManufactureTabs] Error during initialization:", error);
    }
  }

  activateTab(tab) {
    try {
      const tabKey = tab.getAttribute("data-manufacture-tab");

      this.detailsItems.forEach((item) => {
        console.log(item)
        const itemKey = item.getAttribute("data-manufacture-item");
        if (itemKey === tabKey) {
          const header = document.querySelector("#shopify-section-header");
          const headerHeight = header ? header.offsetHeight : 0;
          const elementTop = item.getBoundingClientRect().top +
            window.pageYOffset;
          const offsetPosition = elementTop - headerHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
        return;
      });
    } catch (error) {
      console.error("[ManufactureTabs] Error while activating tab:", error);
    }
  }
}

customElements.define("manufacture-tabs", ManufactureTabs);
